import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'epin/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            console.log(response.data);
            return {
                status: 200,
                epins: response.data.epins,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}


const GetByEpinPurchaseId = async (epinPurchaseId, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            `${config.apiUrl}epin/get-by-epin-purchase-id?epinPurchaseId=${epinPurchaseId}&page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
        console.log("Response status:", response);
        if (response.status === 200) {
            return {
                status: 200,
                epins: response.data.epins,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
};


export { GetAll, GetByEpinPurchaseId };

